module.exports = __webpack_public_path__ + "media/images/icons/uhs_logo-21beb44b904e2a3b5860d78e18a4493f.png";